"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const Main_1 = __importDefault(require("@/components/Main"));
const EditProductAssociationSection_1 = __importDefault(require("@/pages/Products/components/EditProductAssociationSection"));
function EditProductView() {
    return (react_1.default.createElement(Main_1.default, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 4 },
            react_1.default.createElement(EditProductAssociationSection_1.default, null))));
}
exports.default = EditProductView;
